var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NebulaVueSelect',{staticClass:"sort-dropdown",attrs:{"clearable":false,"is-searchable":false,"options":_vm.options,"placeholder":"Sort by","size":"s"},on:{"change-selected":_vm.handleFunction}})
}
var staticRenderFns = []

export { render, staticRenderFns }